export default __webpack_public_path__ + "static/tyre26-fbe27468edf9444e62c0b38a3ecf9795.webp";